<template>
    <div class="step-finished col-12 mt-4">
        <div class="d-flex justify-content-center">
            <div class="mt-5 mb-1 box box-secondary" style="max-width: 234px; width: 100%;">
                <div class="text-center">
                    <h5>{{ t('settings-connections-steps-test_completed_success') }}</h5>
                    <div class="text-xs">
                        {{ displayMessage }}
                    </div> 
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-center mt-2 mb-5">
            <a href="#" @click.prevent="$emit('retry-test')" class="text-danger text-xs">
                <span>{{ t('settings-connections-steps-did_not_receive_test') }}</span>
            </a>
        </div>
        <div class="action-buttons mt-5">
            <button class="btn btn-secondary" @click="$emit('back')">{{ t('settings-connections-steps-back') }}</button>
            <button class="btn btn-success" @click="$emit('done')">
                <Icon icon-class="uiarrow-narrow-right" size="4" />
                <span>{{ t('settings-connections-steps-done') }}</span>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StepFinished',
    props: {
        /**
         * Channel type for default message
         */
        channel: {
            type: String,
            default: null,
        },
        /**
         * Custom message (overrides channel default)
         */
        message: {
            type: String,
            default: null,
        },
    },
    computed: {
        displayMessage() {
            if (this.message) return this.message;
            const map = {
                'whatsapp': 'settings-connections-steps-channel_ready_whatsapp',
                'sms': 'settings-connections-steps-channel_ready_sms',
                'rcs': 'settings-connections-steps-channel_ready_rcs',
                'email': 'settings-connections-steps-channel_ready_email',
                'whatsapp-cloud': 'settings-connections-steps-channel_ready_whatsapp_cloud',
            };
            return this.$_(map[this.channel] || 'settings-connections-steps-channel_ready_default');
        },
    },
};
</script>

<style scoped lang="less">
.step-finished {
    .box {
        padding: 20px;
    }

    .action-buttons {
        display: flex;
        gap: 12px;
        justify-content: stretch;
        
        button {
            flex: 1;
            justify-content: center;
        }
    }
}
</style>

